import { border, ink, focus } from "../UI/tokens";
import styled from "styled-components";
import { btnReset } from "../../styles/variables";
import { Col, FormLabel, Row } from "react-bootstrap";

export const SThemeToggler = styled.button`
    margin: 8px 0;
    ${btnReset};
    margin: 0 auto;
    cursor: pointer;
    width: 36px;
    height: 20px;
    border-radius: 10px;
    background: ${({ theme, $isactive }) => (!$isactive ? theme.bg2 : theme.primary)};

    border: 1px solid #888;
    position: relative;

${focus}
`;

export const SToggleThumb = styled.div`
    height: 18px;
    width: 18px;
    position: absolute;
    top: 0;
    bottom: 1px;
    transition: 0.2s ease right;
    border: 1px solid #888;
    right: calc(100% - 18px - 1px);
    border-radius: 50%;
    background: ${({ $isactive }) => (!$isactive ? "rgb(21,37,92)" : "rgb(167,169,172)")};
`;

export const UsuarioLogado = styled(FormLabel)`
    border: none;
    background: ${({ theme }) => theme.bgAlpha};
    margin: 8px 0;

background: transparent; font-size: 13px; font-weight: 600;
`;

export const Usuario = styled(FormLabel)`
    margin-right: 10px;
`;


export const RowTop = styled(Row)`
    background: ${({ theme }) => theme.bg};
    text-align: center;
    align-items: center;
    width: 100%;
    margin: 0px 0vw;

    [class*="col-md"]{
        text-align: center;
        align-items: center;
    }

border-bottom: 1px solid ${border}; min-height: 64px; padding: 8px 16px; color: ${ink};
`;

export const ColTop = styled(Col)`
    padding: 1vh 0px;
    
    @media (max-width: 575.98px) {
      display: none;
    }

padding: 4px 8px; svg { cursor: pointer; font-size: 19px; }
`;